import { createContext, useContext } from "react";

// Lets any descendant (charts, tables) ask the chat to jump to the bottom the
// moment it renders — so late-growing content never leaves us mid-conversation.
const ChatScrollContext = createContext<() => void>(() => {});

export const ChatScrollProvider = ChatScrollContext.Provider;

export function useScrollToBottom(): () => void {
  return useContext(ChatScrollContext);
}
